@use "@design/components/custom-scroll/custom-scroll" as *;

.root {
  display: flex;
  margin: 0 auto;
  padding: 40px 0;
  gap: 8px;
  max-width: 1200px;
  flex-grow: 1;

  &.unsetMaxWidth {
    max-width: unset;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;

    .content {
      flex: 1;
    }
  }
}

.content {
  width: 100%;
  min-height: 0;
  padding-right: 12px;
  overflow-y: auto;
  @include custom-scroll-minimal;
}

.printableContent {
  display: contents;
}

.sideNav {
  position: sticky;
  top: 24px;
  align-self: flex-start;
  flex-shrink: 0;
  padding-right: 24px;
}

.emptyState {
  min-height: 70dvh;
}
